module.exports = __webpack_public_path__ + "img/dropdown.be967719.svg";